import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { CrosslistSubnav, PageIntro } from "@/components/SellerToolsNav";

export default function Analytics() {
  const [days, setDays] = useState(30);
  const [label, setLabel] = useState("");
  const { data: labels } = useQuery({
    queryKey: ["seller-labels"],
    queryFn: async () => (await api.get("/seller/labels")).data,
  });
  const { data, isLoading } = useQuery({
    queryKey: ["seller-analytics", days, label],
    queryFn: async () => (await api.get(`/seller/crosslist/analytics?days=${days}&label_id=${label}`)).data,
  });

  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-28 pb-24" data-testid="seller-analytics">
      <CrosslistSubnav />
      <PageIntro
        kicker="Crosslist"
        title="Analytics"
        blurb="Revenue from Shoptosa orders, listed vs sold flags, and mix by brand and category. Filter by date range and label."
      />
      <div className="flex flex-wrap gap-3 mb-8">
        {[7, 30, 90, 365].map((d) => (
          <button key={d} type="button" onClick={() => setDays(d)} className={`px-3 py-1.5 text-xs rounded-full border ${days === d ? "bg-aura-accent text-white border-aura-accent" : "border-aura-border"}`}>
            {d === 365 ? "Year" : `${d}d`}
          </button>
        ))}
        <select value={label} onChange={(e) => setLabel(e.target.value)} className="px-3 py-1.5 text-xs border border-aura-border rounded-lg bg-aura-surface">
          <option value="">All labels</option>
          {(labels?.labels || []).map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
        </select>
      </div>
      {isLoading || !data ? <div className="h-40 shimmer rounded-lg" /> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {[
              ["Revenue", `$${data.revenue}`],
              ["Sold units", data.sold_units],
              ["ASP", `$${data.asp}`],
              ["Live", data.live],
            ].map(([k, v]) => (
              <div key={k} className="bg-aura-surface border border-aura-border rounded-lg p-5">
                <div className="text-2xl font-mono">{v}</div>
                <div className="text-xs text-aura-muted mt-1">{k}</div>
              </div>
            ))}
          </div>
          <h2 className="font-medium mb-3">By marketplace</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10">
            {(data.by_channel || []).map((c) => (
              <div key={c.name} className="border border-aura-border rounded-lg p-4 text-sm">
                <div>{c.name}</div>
                <div className="text-xs text-aura-muted mt-1 font-mono">listed {c.listed} · sold {c.sold} · ${c.revenue}</div>
              </div>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 gap-8">
            <div>
              <h2 className="font-medium mb-3">Top brands</h2>
              {(data.top_brands || []).map((b) => <div key={b.name} className="text-sm py-1 flex justify-between"><span>{b.name}</span><span className="font-mono text-aura-muted">{b.count}</span></div>)}
            </div>
            <div>
              <h2 className="font-medium mb-3">Top categories</h2>
              {(data.top_categories || []).map((b) => <div key={b.name} className="text-sm py-1 flex justify-between"><span>{b.name}</span><span className="font-mono text-aura-muted">{b.count}</span></div>)}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
